import React, { Component } from "react";
import DragSortableList from "../../../../../CC_cubi_clan_project/GlobalComponents/DragSortableList/DragSortableList";
import { toDataUrl, getStableKey, resolveParentIndex } from "../../../../../CC_cubi_clan_project/GlobalComponents/DragSortableList/dndUtils";
import { mfmFramedUrl } from "../../../../../CC_cubi_clan_project/Utils/MfmService";
import "./VenuesSection.css";

const WIDE_FORMAT_KEY = "ratio:16:9";

/**
 * VenuesSection
 * Props:
 *  - venues: [{
 *      idRepresentacion?, name?, description?, fechas?, imageBase64?, address?, sortOrder?
 *    }]
 *  - onEdit(index, item)        // índice REAL en el array del padre
 *  - onCreate()
 *  - onChange(updatedArray)     // DragSortableList devuelve array reindexado (sortOrder = i+1)
 */

// Extractores de ID (prioridad) para Venues: idRepresentacion
const venueId = (v) => v?.idRepresentacion;

// Fallback para nuevos sin ID (coincidencia por título)
const fallback = (a, b) =>
  !a?.idRepresentacion &&
  (a?.name || "") === (b?.name || "");

export default class VenuesSection extends Component {
  static defaultProps = { venues: [] };

  handleReorder = (updated) => {
    this.props.onChange && this.props.onChange(updated);
  };

  handleEditClick = (visibleIndex, venue) => {
    const parentArr = this.props.venues || [];
    const realIndex = resolveParentIndex(parentArr, venue, [venueId], fallback);
    const indexForParent = realIndex >= 0 ? realIndex : visibleIndex;

    this.props.onEdit && this.props.onEdit(indexForParent, venue);
  };

  renderItem = (venue, idx, { over }) => {
    const img = venue?.imageUuid
      ? mfmFramedUrl(venue.imageUuid, 320, 180, WIDE_FORMAT_KEY)
      : toDataUrl(venue?.imageBase64);

    return (
      <div
        className={`venue-card ${over ? "is-over" : ""}`}
        onClick={() => this.handleEditClick(idx, venue)}
        title={`Orden ${venue?.sortOrder || idx + 1}`}
      >
        {/* Miniatura 16:9 */}
        <div className="venue-thumb">
          {img
            ? <img src={img} alt={venue?.name || "Lugar"} />
            : <div className="venue-thumb--empty"><i className="fas fa-map-marker-alt" /></div>}
        </div>

        {/* Cuerpo (misma estructura que vista pública) */}
        <div className="venue-body">
          <div className="venue-name">{venue?.name || "\u00A0"}</div>
          {venue?.address && (
            <div className="venue-address"><i className="fas fa-map-pin me-1" />{venue.address}</div>
          )}
          {(venue?.fechas?.length || 0) > 0 && (
            <div className="venue-sessions">
              <i className="fas fa-calendar-check me-1" />
              {venue.fechas.length} {venue.fechas.length === 1 ? "pase" : "pases"}
            </div>
          )}
          {venue?.description && (
            <p className="venue-desc">{venue.description}</p>
          )}
          <div className="d-flex align-items-center justify-content-between mt-1">
            <span className="venue-edit-label">Editar</span>
            {String(venue?.status || "draft").toLowerCase() === "published"
              ? <span className="venue-status-badge venue-status-published"><i className="fas fa-globe me-1" />Publicado</span>
              : <span className="venue-status-badge venue-status-draft"><i className="fas fa-pencil-alt me-1" />Borrador</span>
            }
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { venues, onCreate } = this.props;

    return (
      <section className="venues-section section-block">
        <h3 className="project-subtitle">Lugares de representación</h3>

        {/* DnD centralizado: orden + reindexado */}
        <DragSortableList
          items={venues}
          orderProp="sortOrder"
          getKey={(item, idx) => getStableKey(item, idx, [venueId])}
          renderItem={this.renderItem}
          onChange={this.handleReorder}
        />

        {/* Tile estándar “Añadir …” (mismo que en el resto de secciones) */}
        <div className="section-add-tile" onClick={() => onCreate && onCreate()}>
          <span className="section-add-plus">＋</span>
          <span>Añadir lugar</span>
        </div>
      </section>
    );
  }
}
